import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { SimpleModalComponent } from '../../../app/content/layout/components/modals/simple-modal/simple-modal.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<SimpleModalComponent> = {
  title: 'Molecules/Modals/Simple Modal',
  component: SimpleModalComponent,
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<SimpleModalComponent>;

export const Default: Story = {
  args: {
    title: 'Information',
    text: 'Din ordre er blevet bekræftet. Du modtager en e-mail med ordrebekræftelsen.',
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Information')).toBeInTheDocument();
  },
};

export const WarningMessage: Story = {
  args: {
    title: 'Advarsel',
    text: 'Du er ved at forlade siden. Dine ændringer er ikke gemt.',
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText('Advarsel')).toBeInTheDocument();
  },
};
